export const ARTICLES = [
  {
    slug: "choisir-sous-traitant-fibre-optique",
    title: "Comment choisir un sous-traitant fibre optique ?",
    description:
      "Critères concrets pour sélectionner un sous-traitant fibre optique fiable : expérience terrain, traçabilité, capacité de mobilisation et double compétence travaux-contrôle.",
    intro:
      "Confier des travaux de raccordement ou de maintenance à un sous-traitant engage la qualité de votre réseau et votre image auprès de vos clients. Voici les points qui distinguent un partenaire fiable d'un simple exécutant.",
    sections: [
      {
        h2: "Vérifier l'expérience terrain",
        paragraphs: [
          "Un sous-traitant fibre optique se juge d'abord sur ses interventions réalisées : raccordements FTTH, travaux sur points de mutualisation, reprises après incident. Demandez des exemples de chantiers documentés, avec photos et comptes rendus, plutôt qu'une simple plaquette commerciale.",
          "L'expérience terrain se reconnaît aussi à la manière de préparer une mission : un prestataire sérieux pose des questions sur les accès, les référentiels applicables et les contraintes de sécurité avant de chiffrer.",
        ],
      },
      {
        h2: "Exiger la traçabilité des interventions",
        paragraphs: [
          "Chaque intervention doit être documentée : localisation, constats, photos, mesures et suites données. Sans traçabilité, impossible de prouver la conformité d'un raccordement ni de suivre les écarts.",
          "Vérifiez que le prestataire sait produire des remontées exploitables par vos équipes qualité — c'est la différence entre un rapport qui dort et un rapport qui fait avancer.",
        ],
      },
      {
        h2: "Évaluer la capacité de mobilisation",
        paragraphs: [
          "Un bon sous-traitant doit pouvoir monter en charge sur vos volumes et couvrir vos zones d'exploitation. Interrogez-le sur ses délais de mobilisation, son organisation d'équipes et sa gestion des astreintes éventuelles.",
        ],
      },
      {
        h2: "La double compétence travaux et contrôle",
        paragraphs: [
          "Un prestataire qui réalise les travaux ET contrôle leur qualité connaît les points de non-conformité les plus fréquents. Cette double casquette, comme celle d'ATLAS THD, sécurise la chaîne : les mêmes équipes comprennent les deux côtés du référentiel.",
        ],
      },
      {
        h2: "Les questions à poser avant de contractualiser",
        paragraphs: [
          "Quels référentiels appliquez-vous ? Comment documentez-vous une anomalie ? Quels sont vos délais de mobilisation sur notre zone ? Comment sont suivies les reprises ? Un partenaire transparent répond précisément à chacune de ces questions.",
        ],
      },
    ],
  },
  {
    slug: "etapes-raccordement-ftth-d3",
    title: "Les étapes d'un raccordement FTTH D3",
    description:
      "Du repérage à la mesure optique : les étapes concrètes d'un raccordement FTTH sur le segment D3, la dernière portion du lien jusqu'à l'abonné.",
    intro:
      "Le segment D3 désigne la dernière portion du réseau FTTH : celle qui relie le point de branchement à la prise terminale chez l'abonné ou dans les locaux professionnels. C'est la partie la plus exposée aux contraintes terrain — accès, façades, parties communes — et donc la plus déterminante pour la satisfaction finale.",
    sections: [
      {
        h2: "1. Préparation et repérage",
        paragraphs: [
          "Avant toute intervention, le technicien vérifie l'adressage, le cheminement prévu, les conditions d'accès et les éventuelles autorisations nécessaires (voirie, syndic, occupant). Une bonne préparation évite l'essentiel des échecs de raccordement.",
        ],
      },
      {
        h2: "2. Acheminement de la fibre",
        paragraphs: [
          "Selon l'infrastructure, l'acheminement se fait en aérien sur façade, en souterrain dans les fourreaux existants, ou en parties communes pour l'habitat collectif. Le respect du cheminement et des règles de pose conditionne la durabilité de la liaison.",
        ],
      },
      {
        h2: "3. Soudure et pose de la prise terminale",
        paragraphs: [
          "La fibre est soudée au point de branchement, puis la prise terminale optique (PTO) est posée et repérée dans le logement ou le local. La propreté de l'installation et le respect du point de passage convenu font partie de la qualité d'exécution.",
        ],
      },
      {
        h2: "4. Mesures et vérifications",
        paragraphs: [
          "Des mesures optiques (réflectométrie, mesure de puissance) valident la conformité de la liaison. Tout écart constaté à ce stade doit être corrigé avant la clôture de l'intervention.",
        ],
      },
      {
        h2: "5. Compte rendu et traçabilité",
        paragraphs: [
          "L'intervention se termine par un compte rendu documenté : photos avant/après, mesures, repérage de la prise. Cette restitution permet au donneur d'ordre de valider le raccordement et d'alimenter ses systèmes d'information.",
        ],
      },
    ],
  },
  {
    slug: "pourquoi-externaliser-raccordement-ftth",
    title: "Pourquoi externaliser ses travaux de raccordement FTTH ?",
    description:
      "Montée en charge, compétences spécialisées, couverture géographique : pourquoi les opérateurs et entreprises de déploiement externalisent le raccordement FTTH.",
    intro:
      "Les déploiements FTTH se font par campagnes, avec des pics de volume impossibles à absorber en interne. L'externalisation à un sous-traitant spécialisé est devenue le modèle standard du secteur — à condition de bien le piloter.",
    sections: [
      {
        h2: "Absorber les volumes sans recruter",
        paragraphs: [
          "Une campagne de raccordements peut représenter des centaines de prises sur quelques semaines. Externaliser permet de mobiliser des équipes formées uniquement quand le volume l'exige, sans alourdir la structure.",
        ],
      },
      {
        h2: "Accéder à des compétences spécialisées",
        paragraphs: [
          "Soudure, mesures optiques, interventions en hauteur, habitat collectif : le raccordement exige des habilitations et un savoir-faire qui s'entretiennent par la pratique quotidienne. Un sous-traitant spécialisé les capitalise pour vous.",
        ],
      },
      {
        h2: "Sécuriser la qualité par le contrôle",
        paragraphs: [
          "Externaliser ne signifie pas déléguer la qualité. Au contraire : les prestations d'inspection et de contrôle de conformité permettent de vérifier, échantillon par échantillon, que les travaux respectent vos référentiels. ATLAS THD combine les deux activités — travaux et contrôle — pour boucler cette chaîne.",
        ],
      },
      {
        h2: "Gagner en souplesse géographique",
        paragraphs: [
          "Un réseau de sous-traitants régionaux couvre vos zones d'exploitation sans multiplier vos implantations. L'essentiel est de retenir des partenaires capables de documenter leurs interventions de manière homogène, où qu'ils interviennent.",
        ],
      },
      {
        h2: "Les points de vigilance",
        paragraphs: [
          "Externalisation réussie suppose un référentiel clair, des comptes rendus normalisés et un suivi des écarts rigoureux. C'est sur ces trois points que se jouent la qualité perçue par l'abonné et la rentabilité de vos campagnes.",
        ],
      },
    ],
  },
];
